var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6644 10.0411C17.6644 9.40292 17.6071 8.78929 17.5008 8.2002H9.02441V11.6816H13.8681C13.6594 12.8066 13.0253 13.7597 12.0721 14.3979V16.6561H14.9808C16.6826 15.0893 17.6644 12.782 17.6644 10.0411Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02417 18.8369C11.4542 18.8369 13.4914 18.031 14.9805 16.6564L12.0719 14.3982C11.266 14.9382 10.2351 15.2573 9.02417 15.2573C6.68008 15.2573 4.69599 13.6741 3.98826 11.5469H0.981445V13.8787C2.46235 16.8201 5.50599 18.8369 9.02417 18.8369Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9885 11.5467C3.8085 11.0067 3.70623 10.4299 3.70623 9.83674C3.70623 9.24356 3.8085 8.66674 3.9885 8.12674V5.79492H0.981687C0.372141 7.00992 0.0244141 8.38447 0.0244141 9.83674C0.0244141 11.289 0.372141 12.6636 0.981687 13.8786L3.9885 11.5467Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02417 4.41646C10.3455 4.41646 11.5319 4.87055 12.4646 5.76237L15.046 3.18101C13.4874 1.72873 11.4501 0.836914 9.02417 0.836914C5.50599 0.836914 2.46235 2.85373 0.981445 5.7951L3.98826 8.12691C4.69599 5.99964 6.68008 4.41646 9.02417 4.41646Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2744b72aee9903898fa1eb34e82ff14d.svg";
export { ForwardRef as ReactComponent };